module.exports = __webpack_public_path__ + "audio/elevenAudio.96b7883e.mp3";